export enum ActivityStreamAllocationPropertyType {
  AllocationManagerId = 'AllocationManagerId',
  IndividualMultiplierManagerId = 'IndividualMultiplierManagerId'
}
